<script>
import { getCurrentAddress } from '@/utils/helpers'

export default {
  name: 'AutoComplete',
  props: {
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      default: 'Enter value',
    },
    inputClass: {
      type: String,
      default: 'border-0 ml-1',
    },
    inputDisabled: {
      type: Boolean,
      default: false,
    },
    destination: {
      type: Boolean,
      default: false,
    },
    google: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      location: '',
      currentAddress: null,
      inputFocused: false,
      showError: false,
    }
  },
  computed: {
    showUserCurrentLocation() {
      return !this.value && this.inputFocused
    },
  },
  created() {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.inputFocused = false
      }
    })
  },
  async mounted() {
    this.initAutocomplete()
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    },
    clearValue() {
      this.$emit('input', null)
    },
    initAutocomplete() {
      const defaultBounds = this.google.maps.LatLngBounds(
        new this.google.maps.LatLng(57.001210162832436, -2.9457858869887343),
        new this.google.maps.LatLng(57.72991624947179, -1.7592624494887343),
      )
      this.autocomplete = new this.google.maps.places.Autocomplete(this.$refs.autocomplete, {
        componentRestrictions: { country: 'gb' },
        bounds: defaultBounds,
      })
      this.autocomplete.addListener('place_changed', () => {
        this.$emit('input', this.$refs.autocomplete.value)
      })
    },
    getCurrenLocation() {
      this.showError = false
      navigator.geolocation.getCurrentPosition(
        (position) => {
          getCurrentAddress({ lat: position.coords.latitude, lng: position.coords.longitude }).then((result) => {
            if (result.showError) {
              this.inputFocused = false
              this.showError = true
            } else {
              this.currentAddress = result.address
              this.$emit('input', this.currentAddress)
            }
          })
        },
        (error) => {
          if (error) {
            this.inputFocused = false
            this.showError = true
          }
        },
      )
    },
    onFocus() {
      this.inputFocused = true
    },
    showMapDestination() {
      this.$emit('showMapDestination')
    },
  },
}
</script>

<template>
  <div class="w-100 origin location">
    <div
      class="input-style"
      style="float: left"
      :title="value"
    >
      <input
        ref="autocomplete"
        type="text"
        :disabled="inputDisabled"
        :placeholder="placeholder"
        :class="inputClass"
        class="input-float"
        :value="value"
        aria-label="input for location"
        @input="updateValue($event.target.value)"
        @focus="onFocus"
      />
      <div
        v-if="value && !inputDisabled"
        class="clear-value"
        @click="clearValue"
      >
        <svg-icon
          name="cross"
          style="transform: rotate(45deg)"
          class="mx-1"
          width="20"
        />
      </div>
    </div>
    <ul
      v-if="showUserCurrentLocation"
      class="current-location-trigger"
    >
      <li @click="getCurrenLocation">
        <svg-icon
          name="location"
          width="45"
          :color="$whitelabel.brand == 'sestran' ? '#ff8672' : ''"
        />
        Use current location
      </li>
      <li
        v-if="destination"
        @click="showMapDestination"
      >
        <svg-icon
          name="choose-on-map"
          width="45"
          :color="$whitelabel.brand == 'sestran' ? '#ff8672' : ''"
        />
        Choose on map
      </li>
    </ul>
    <div class="container w-100 m-0 p-0 pt-1">
      <span
        v-if="showError && !currentAddress"
        class="form-error border-0 ml-2 w-100"
      >
        Cannot get the current location
      </span>
    </div>
  </div>
</template>

<style scoped>
.clear-value {
  position: absolute;
  display: inline-block;
  top: -1px;
  right: -24px;
}
</style>
